import { render, staticRenderFns } from "./ModalFirmaDigital.vue?vue&type=template&id=0a653b9a&scoped=true"
import script from "./ModalFirmaDigital.vue?vue&type=script&lang=js"
export * from "./ModalFirmaDigital.vue?vue&type=script&lang=js"
import style0 from "./ModalFirmaDigital.vue?vue&type=style&index=0&id=0a653b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a653b9a",
  null
  
)

export default component.exports